"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = exports.HeaderWrapper = exports.ContentWrapper = exports.CollapseButton = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _Button = _interopRequireDefault(require("../Button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const styles = exports.styles = {
  default: theme => /*#__PURE__*/(0, _react.css)("position:relative;border-radius:4px;background:#ffffff;box-shadow:", theme.shadowSmall, ";&>button{width:100%;display:block;}" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  mysite: theme => /*#__PURE__*/(0, _react.css)("padding:0.5em 0;border-radius:", theme.mypageBoxBorderRadius, ";box-shadow:", theme.mypageBoxShadow, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:mysite;")),
  noshadow: process.env.NODE_ENV === "production" ? {
    name: "1t90u8d",
    styles: "box-shadow:none"
  } : {
    name: "1u50o93-noshadow",
    styles: "box-shadow:none;label:noshadow;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  background: bg => /*#__PURE__*/(0, _react.css)("background:", bg, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:background;"))
};
const HeaderWrapper = exports.HeaderWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ez14oqn2"
} : {
  target: "ez14oqn2",
  label: "HeaderWrapper"
})(props => `
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  border-bottom: ${props.border ? '1px solid #d7d7d7' : 'none'};

  svg {
    align-self: center;
  }
`);
const ContentWrapper = exports.ContentWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ez14oqn1"
} : {
  target: "ez14oqn1",
  label: "ContentWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "6p1aet",
  styles: "display:block;padding:1.5rem"
} : {
  name: "6p1aet",
  styles: "display:block;padding:1.5rem",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const CollapseButton = exports.CollapseButton = /*#__PURE__*/(0, _base.default)(_Button.default, process.env.NODE_ENV === "production" ? {
  target: "ez14oqn0"
} : {
  target: "ez14oqn0",
  label: "CollapseButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1082qq3",
  styles: "display:block;width:100%"
} : {
  name: "1082qq3",
  styles: "display:block;width:100%",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var _default = exports.default = styles;